import { getConfigApi } from '../config'
import { getFetch, postFetch, putFetch, deleteFetch } from 'utils/fetch'

function getUrl(prefix = '') {
  return getConfigApi().user + '/' + prefix
}

export function getUsers(
  { page = 1, itemPerPage = 10 },
  { userName, email, firstName, lastName, organization, phone }
) {
  let urlSearch = getUrl(`admin?page=${page}&itemPerPage=${itemPerPage}`)
  if (userName) urlSearch += `&username=${userName}`
  if (email) urlSearch += `&email=${email}`
  if (firstName) urlSearch += `&firstName=${firstName}`
  if (lastName) urlSearch += `&lastName=${lastName}`
  if (organization) urlSearch += `&organization=${organization}`
  if (phone) urlSearch += `&phone=${encodeURIComponent(phone)}`

  return getFetch(urlSearch)
}

export function createUser(data = {}) {
  return postFetch(getUrl('admin'), data)
}

export function setPassword(data = {}) {
  return postFetch(getUrl('admin/set-password'), data)
}

export function getUserById(_id) {
  return getFetch(getUrl(`admin/${_id}`))
}

export function updateUser(_id, user = {}) {
  return putFetch(getUrl(`admin/${_id}`), user)
}

export function removeUser(_id) {
  return deleteFetch(getUrl(`admin/${_id}`))
}

export function deleteUser(_id) {
  return putFetch(getUrl(`admin/delete/${_id}`))
}

export function restoreUser(_id) {
  return putFetch(getUrl(`admin/restore/${_id}`))
}

export function accountEnable(_id, data = {}) {
  return putFetch(getUrl(`admin/enable/${_id}`), data)
}

export default {
  getUsers,
  createUser,
  updateUser,
  getUserById,
  removeUser,
  deleteUser,
  restoreUser,
  accountEnable,
  setPassword
}



// WEBPACK FOOTER //
// ./src/api/UserApi.js